export const TRAINING_HALF_DAY_AMOUNT = 422;

export const computeTrainingAmountForDay = ({ perdiems = [] }) =>
  perdiems.length ? perdiems.length * TRAINING_HALF_DAY_AMOUNT : 0;

const computeExpectedAmountForTraining = ({ days = [] }) =>
  days.reduce((acc, day) => acc + computeTrainingAmountForDay(day), 0).toFixed(2);

export default computeExpectedAmountForTraining;
